import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const registerUser = async (userData) => {
  const res = await axios.post(`${API_URL}/api/register`, userData);
  return res.data;
};

export const loginUser = async (credentials) => {
  const res = await axios.post(`${API_URL}/api/login`, credentials);
  return res.data;
};

// ✅ Forgot Password (Send OTP)
export const forgotPassword = async (phone) => {
  const res = await axios.post(`${API_URL}/api/forgot-password`, { emailOrPhone: phone });
  return res.data;
};

// ✅ Verify OTP
// export const verifyOTP = async (phone, otp) => {
//      console.log("VERIFY API CALLED WITH:", phone, otp);
//   const res = await axios.post(`${API_URL}/api/verify-otp`, { phone, otp });
//   return res.data;
// };
export const verifyOTP = async (data) => {
  const res = await axios.post(`${API_URL}/api/verify-otp`, data);
  return res.data;
};
// ✅ Reset Password using OTP
export const resetPasswordOTP = async (phone, otp, newPassword) => {
    console.log("RESET API CALLED WITH:", { phone, otp, newPassword });
  const res = await axios.post(`${API_URL}/api/reset-password-otp`, {
    phone,
    otp,
    newPassword,
  });
  return res.data;
};